import { readdir, readFile, stat } from 'node:fs/promises';
import { join } from 'node:path';
import { extractHttpError } from '@wix/cli-http-client';

/**
 * reads a file contents recursively and returns an array of all files
 */
export async function readFiles(
  dir: string,
  subPath = ''
): Promise<Array<{ path: string; content: string }>> {
  return (
    await Promise.all(
      (await readdir(join(dir, subPath))).map(async (file) => {
        const path = join(subPath, file);
        if ((await stat(join(dir, path))).isDirectory()) {
          return readFiles(dir, path);
        }
        return {
          path,
          content: await readFile(join(dir, path), 'utf-8'),
        };
      })
    )
  ).flat();
}

export function isSiteNotPublishedError(err: unknown) {
  if (err instanceof Error) {
    const httpError = extractHttpError(err);
    const errorCode =
      httpError?.response?.data?.details?.applicationError?.code;

    if (errorCode === 'SITE_NOT_PUBLISHED') {
      return true;
    }
  }
  return false;
}
